import React, { Component } from 'react';
import Layout from './Layout';
import './App.css';

class App extends Component {
  render() {
    return (
      <Layout />
    );
  }
}

export default App;